import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpEvent, HttpEventType, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  // ========================
  // BASIC METHODS
  // ========================

  get<T>(endpoint: string, params?: any): Observable<T> {
    return this.http.get<T>(this.buildUrl(endpoint), {
      params: this.buildParams(params),
    });
  }

  post<T, TPayload>(endpoint: string, body: TPayload): Observable<T> {
    return this.http.post<T>(this.buildUrl(endpoint), body);
  }

  put<T, TPayload>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(this.buildUrl(endpoint), body);
  }

  delete<T>(endpoint: string, params?: any): Observable<T> {
    return this.http.delete<T>(this.buildUrl(endpoint), {
      params: this.buildParams(params),
    });
  }

  // ========================
  // FORM DATA (NO PROGRESS)
  // ========================

  postFormData<T>(endpoint: string, formData: FormData): Observable<T> {
    return this.http.post<T>(this.buildUrl(endpoint), formData);
  }

  // ========================
  // FORM DATA WITH PROGRESS
  // ========================

  uploadWithProgress(
    endpoint: string,
    formData: FormData,
  ): Observable<{ progress: number; response?: any }> {
    return this.http
      .post(this.buildUrl(endpoint), formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round(100 * (event.loaded / (event.total || 1)));
              return { progress };

            case HttpEventType.Response:
              return {
                progress: 100,
                response: event.body,
              };

            default:
              return { progress: 0 };
          }
        }),
      );
  }

  // ========================
  // HELPERS
  // ========================

  private buildUrl(endpoint: string): string {
    return `${this.baseUrl}/${endpoint}`;
  }

  private buildParams(params?: any): HttpParams {
    let httpParams = new HttpParams();

    if (params) {
      Object.keys(params).forEach((key) => {
        const value = params[key];

        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, String(value)); // ✅ FIX
        }
      });
    }

    return httpParams;
  }
}
